export const enumDecode = (enumValues, jsonValue) =>
  enumValues.values().find((enumValue) => enumValue === jsonValue);
